$(function(){
   $(".mobile_tab_btn").on("click", function(){
    if ($(this).next(".mobile_tab_list").hasClass('show')){
        $(this).next(".mobile_tab_list").removeClass('show');
    }else {
        $(this).next(".mobile_tab_list").addClass('show');
    }
   });
   $('.side-menu ul a, .side-tabs .mobile_tab_list button').on('click', function(){
    $('.mobile_tab_btn').next('.mobile_tab_list').removeClass("show");
   });
    $('.filter-arrow-right').on("click", function(){
        $('.collection-filter__scrollable').animate({scrollLeft: '+=300px'}, 500);
    });
    $('.bundle-builder--remove-from-bundle-form').on('click', function(){

    });

    $(".scent_slideshow .slides").slick({
        infinite:true,
        dots:true
    });
    $(".scent_slideshow .img_wrapper button").on('click', function(){
        console.log('hii');
        if ($(this).siblings(".second").hasClass('hidden')){
            $(this).html('2/2');
        } else {
            $(this).html('1/2');
        }
        $(this).siblings(".second").toggleClass('hidden');
    })
   let tl = gsap.timeline({ repeat: -1,defaults: { ease: "linear"} });
   const color1 = "#F8AEAF";
   const color2 = "#F5B0B0";
   const color3 = "rgba(234, 180, 181, 1)";
   const color4 = "#D8BCBD";
   const color5 = "#BFC7C8";
   const color6 = "#A9D1D1";
   const color7 = "#A3C8A3";
   const color8 = "#B5CA9D";
   const color9 = "#E7CF8C";
   const color10 = "#FAD186";
   tl.fromTo('.forage_template .shopify-section:first-of-type', {background:"radial-gradient(circle at center, "+ color1 +" 0%, "+ color2 +" 9.84%, "+ color3 +" 18.45%, "+ color4 +" 26.58%, "+ color5 +" 34.39%, "+ color6 +" 39.74%, "+ color7 +" 53%, "+ color8 +" 61.48%, "+ color9 +" 87.27%, "+ color10 +" 100%)" },{background:"radial-gradient(circle at center, "+ color10 +" 0%, "+ color1 +" 9.84%, "+ color2 +" 18.45%, "+ color3 +" 26.58%, "+ color4 +" 34.39%, "+ color5 +" 39.74%, "+ color6 +" 53%, "+ color7 +" 61.48%, "+ color8 +" 87.27%, "+ color9 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color9 +" 0%, "+ color10 +" 9.84%, "+ color1 +" 18.45%, "+ color2 +" 26.58%, "+ color3 +" 34.39%, "+ color4 +" 39.74%, "+ color5 +" 53%, "+ color6 +" 61.48%, "+ color7 +" 87.27%, "+ color8 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color8 +" 0%, "+ color9 +" 9.84%, "+ color10 +" 18.45%, "+ color1 +" 26.58%, "+ color2 +" 34.39%, "+ color3 +" 39.74%, "+ color4 +" 53%, "+ color5 +" 61.48%, "+ color6 +" 87.27%, "+ color7 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color7 +" 0%, "+ color8 +" 9.84%, "+ color9 +" 18.45%, "+ color10 +" 26.58%, "+ color1 +" 34.39%, "+ color2 +" 39.74%, "+ color3 +" 53%, "+ color4 +" 61.48%, "+ color5 +" 87.27%, "+ color6 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color6 +" 0%, "+ color7 +" 9.84%, "+ color8 +" 18.45%, "+ color9 +" 26.58%, "+ color10 +" 34.39%, "+ color1 +" 39.74%, "+ color2 +" 53%, "+ color3 +" 61.48%, "+ color4 +" 87.27%, "+ color5 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color5 +" 0%, "+ color6 +" 9.84%, "+ color7 +" 18.45%, "+ color8 +" 26.58%, "+ color9 +" 34.39%, "+ color10 +" 39.74%, "+ color1 +" 53%, "+ color2 +" 61.48%, "+ color3 +" 87.27%, "+ color4 +" 100%)", duration: 1})
   tl.to('.forage_template .shopify-section:first-of-type',{background:"radial-gradient(circle at center, "+ color4 +" 0%, "+ color5 +" 9.84%, "+ color6 +" 18.45%, "+ color7 +" 26.58%, "+ color8 +" 34.39%, "+ color9 +" 39.74%, "+ color10 +" 53%, "+ color1 +" 61.48%, "+ color2 +" 87.27%, "+ color3 +" 100%)", duration: 1})
   tl.to('#shopify-section-template--16834114060544__advanced-content',{background:"radial-gradient(circle at center, "+ color3 +" 0%, "+ color4 +" 9.84%, "+ color5 +" 18.45%, "+ color6 +" 26.58%, "+ color7 +" 34.39%, "+ color8 +" 39.74%, "+ color9 +" 53%, "+ color10 +" 61.48%, "+ color1 +" 87.27%, "+ color2 +" 100%)", duration: 1})
   tl.to('#shopify-section-template--16834114060544__advanced-content',{background:"radial-gradient(circle at center, "+ color2 +" 0%, "+ color3 +" 9.84%, "+ color4 +" 18.45%, "+ color5 +" 26.58%, "+ color6 +" 34.39%, "+ color7 +" 39.74%, "+ color8 +" 53%, "+ color9 +" 61.48%, "+ color10 +" 87.27%, "+ color1 +" 100%)", duration: 1})
   tl.to('#shopify-section-template--16834114060544__advanced-content',{background:"radial-gradient(circle at center, "+ color1 +" 0%, "+ color2 +" 9.84%, "+ color3 +" 18.45%, "+ color4 +" 26.58%, "+ color5 +" 34.39%, "+ color6 +" 39.74%, "+ color7 +" 53%, "+ color8 +" 61.48%, "+ color9 +" 87.27%, "+ color10 +" 100%)", duration: 1})
});


/* AMA - ADDED EXTRA CODE  23 Oct 2023 */
  
  $(window).scroll(function() { 
    
    var scrollSRV = $(window).scrollTop();
    var widthSRV = $(window).width();
    if(widthSRV < 760) {
      
          if (scrollSRV >= 150  ) {
              $(".site-header").addClass("site-header--sticky site-header--opening");
          } else {
              $(".site-header").removeClass("site-header--sticky site-header--opening");
          }
      }
  });
